import { render } from "./_name.vue?vue&type=template&id=04377dfa&scoped=true"
import script from "./_name.vue?vue&type=script&lang=js"
export * from "./_name.vue?vue&type=script&lang=js"

import "./_name.vue?vue&type=style&index=0&id=04377dfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04377dfa"]])

export default __exports__